import React from "react";

const Person = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1216_15553)">
      <path d="M16 0H0V16H16V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M8 7.33301C9.65685 7.33301 11 5.98986 11 4.33301C11 2.67615 9.65685 1.33301 8 1.33301C6.34315 1.33301 5 2.67615 5 4.33301C5 5.98986 6.34315 7.33301 8 7.33301Z"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinejoin="round"
      />
      <path
        d="M1.66675 14.667C1.66675 11.8545 3.72508 9.22949 5.46675 8.66699C5.46675 8.66699 7.05008 10.3545 8.00008 11.4795L10.5334 8.66699C11.9584 8.85449 14.3334 11.8545 14.3334 14.667"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinejoin="round"
      />
      <path
        d="M0.666748 14.667H15.3334"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1216_15553">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(Person);
